'use strict';

import template from '../../templates/payrolls/Main.ejs';
import PayrollView from './Payroll';

module.exports = Backbone.View.extend({
    events: {
        'click .js-back': 'back'
    },

    initialize: function(options) {
        this.options = {
            company: options.company
        };
        const payrolls = this.collection.map(payroll => {
            const archive = options.attachments[payroll.id]
                .findByTags(['payroll', 'archive', 'ready']).first();
            const calculations = options.attachments[payroll.id]
                .findByTags(['payroll', 'calculations', 'pdf']).first();
            return new PayrollView({
                model: payroll,
                archive: archive,
                calculations: calculations
            });
        });
        this.options.payrolls = payrolls;

        return this;
    },

    render: function() {
        this.$el.html(template({
            payrolls: this.options.payrolls,
            company: this.options.company
        }));

        let $container = this.$('.js-payrolls');
        this.options.payrolls.forEach(payroll => {
            $container.append(payroll.render().$el);
        });

        return this;
    },

    back: function() {
        history.go(-1);
    }

});



// WEBPACK FOOTER //
// ./app/adminManager/views/payrolls/Main.js